unit uGridEditBlock;
{
  This is used to manage a TWebStringGrid, a TWebMemo below it for editing content, and
  related buttons -- mainly a Save button.
}

interface

uses
  System.SysUtils, System.Classes, Types, JS, Web,
  WEBLib.Graphics, WEBLib.Controls, WEBLib.StdCtrls,
  WEBLib.ComCtrls, WEBLib.ExtCtrls, WEBLib.REST, WEBLib.JSON,
  System.StrUtils,
  Vcl.Controls, Vcl.StdCtrls,
  VCL.TMSFNCCustomControl, Vcl.Grids, WEBLib.Grids
  ;

type

  TStringArray = array of string;

  TGridEditBlock = class
  private
    F_SaveRowEdit_btn : TButton;
    F_grid : TStringGrid;
    F_mmo : TMemo;
    FDoNotUpdateThese : TStringArray;
    FCurrentParams : TStringlist;  // only for Parameters, not Name+Descr
    FOnWarning : TProc<string>;

  public
    constructor Create( a_SaveRowEdit_btn : TButton; a_grid : TStringGrid; a_mmo : TMemo );

    procedure DoOnGridClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure DoOnMemoChange(Sender: TObject);
    procedure DoOnSaveRowEdit_btnClick(Sender: TObject);
    procedure ClearGrid();
    procedure ShowWarning( const aWarning : string );
    function  html_type() : string;
    property  DoNotUpdateThese : TStringArray read FDoNotUpdateThese write FDoNotUpdateThese;
    property  CurrentParams : TStringlist read FCurrentParams write FCurrentParams;
    property  OnWarning : TProc<string> read FOnWarning write FOnWarning;

  end;


implementation

{ TGridEditBlock }

//===============================================================
constructor TGridEditBlock.Create(a_SaveRowEdit_btn: TButton; a_grid: TStringGrid; a_mmo: TMemo);
//===============================================================
begin
  F_SaveRowEdit_btn := a_SaveRowEdit_btn;
  F_grid := a_grid;
  F_mmo := a_mmo;
  FDoNotUpdateThese := [];
  FCurrentParams := NIL;
end;

//===============================================================
procedure TGridEditBlock.ClearGrid();
//===============================================================
// #780
var
  c, r : integer;
begin
  with F_grid do
  begin
    FixedFont.Size := Font.Size;
    FixedFont.Style := [fsBold];
    RowCount := 5;
    Cells[0,0] := 'Param Name';
    Cells[1,0] := 'Value';
    for r := 1 to RowCount-1 do
    begin
      Cells[0,r] := '';
      Cells[1,r] := '';
    end;
  end;
end;

//===============================================================
procedure TGridEditBlock.DoOnGridClickCell(Sender: TObject; ACol, ARow: Integer);
//===============================================================
// The aRow value is put into the _SaveRowEdit_btn.Tag field so it knows where to save it
var
  nm, val : string;

begin
  F_SaveRowEdit_btn.Tag := aRow;
  nm := F_grid.Cells[0,aRow];
  val := F_grid.Cells[1,aRow];

  console.log( 'html_type = '+html_type() );

  if (nm = 'options') and MatchText( html_type(), ['select','datalist'] ) then
    F_mmo.Lines.CommaText := val
  else
    F_mmo.Lines.Text := val;
end;

//===============================================================
procedure TGridEditBlock.DoOnMemoChange(Sender: TObject);
//===============================================================
// compares current memo text with original and sets F_SaveRowEdit_btn.Enabled=True
// if they're different
var
  r : integer;
begin
  r := F_SaveRowEdit_btn.Tag;
  F_SaveRowEdit_btn.Enabled := (F_mmo.Lines.Text <> F_grid.Cells[1,r]);
end;

//===============================================================
procedure TGridEditBlock.DoOnSaveRowEdit_btnClick(Sender: TObject);
//===============================================================
// copies _mmo.Lines.Text back to the grid cell that was edited
var
  r, n : integer;
  nm, val : string;
begin
  r := F_SaveRowEdit_btn.Tag;

  nm := F_grid.Cells[0,r];

  if (Length(FDoNotUpdateThese) > 0) then
    if MatchText( nm, FDoNotUpdateThese ) then
    begin
      ShowWarning( 'this item cannot be changed' );
      F_mmo.Lines.Clear;
      Exit;
    end;

  if (nm = 'options') and MatchText( html_type(), ['select','datalist'] ) then
    val := F_mmo.Lines.CommaText
  else
    val := F_mmo.Lines.Text;

  F_grid.Cells[1,r] := val;
  F_SaveRowEdit_btn.Enabled := False;

  // this only works for Parameters so far -- needs to be fixed to work with Name+Descr ###
  if Assigned( FCurrentParams ) then
  begin
    // now update the value in the stringlist so the user can change parameters and go back
    // and the edit is still there
    // We need to look it up since some can be hidden
    n := FCurrentParams.IndexOfName( nm );
    // Assert( n >= 0, '** Can''t find name "'+nm+'" in curr_params_sl' );  doesn't work!
    FCurrentParams.ValueFromIndex[n] := val;
  end;
  F_mmo.Lines.Clear;
end;

//===============================================================
function TGridEditBlock.html_type() : string;
//===============================================================
// this is only for Parameters
var n : integer;
begin
  Result := '';
  if not Assigned( FCurrentParams ) then
    Exit;

  n := FCurrentParams.IndexOfName( 'html_type' );
  if (n >= 0) then
    Result := FCurrentParams.ValueFromIndex[n];
end;

//===============================================================
procedure TGridEditBlock.ShowWarning(const aWarning: string);
//===============================================================
begin
  OnWarning( aWarning );
end;

end.
